import React from 'react'
import { StyleSheet, Text, View, TouchableOpacity, Image } from 'react-native'
import { Ionicons } from '@expo/vector-icons'
import Showstorebar from '../../../../components/user/Showstorebar'

interface HeaderSectionProps {
  firstName: string | undefined
  brandingLogo: string | null | undefined
  navigation: any
}

const HeaderSection = ({
  firstName,
  brandingLogo,
  navigation
}: HeaderSectionProps): JSX.Element => {
  return (
    <View style={styles.headerBanner}>
      <View style={styles.topRow}>
        <View style={styles.leftCol}>
          <TouchableOpacity
            style={styles.welcomeContainer}
            onPress={() => navigation.navigate('Switchscreen')}
          >
            {/* <Ionicons name="person-circle-outline" size={22} color="white" style={styles.welcomeIcon} />
            <Text style={styles.welcomeText}>
              Welcome {firstName ? firstName.toUpperCase() : 'USER'}
            </Text>
            <Ionicons name="chevron-down" size={16} color="white" style={styles.chevronIcon} /> */}
          </TouchableOpacity>

          <View style={styles.storebarContainer}>
            <Showstorebar navigation={navigation} />
          </View>
        </View>
      </View>
    </View>
  )
}

export default HeaderSection

const styles = StyleSheet.create({
  headerBanner: {
    backgroundColor: '#0B495C',
    paddingTop: 12,
    paddingBottom: 25,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0
  },
  topRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    paddingHorizontal: 16
  },
  leftCol: {
    flex: 1,
    justifyContent: 'flex-start'
  },
  rightCol: {
    justifyContent: 'flex-start',
    alignItems: 'flex-end',
    marginLeft: 10
  },
  welcomeContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 10,
    marginTop: 8
  },
  welcomeIcon: {
    marginRight: 6
  },
  welcomeText: {
    color: 'white',
    fontSize: 14,
    fontWeight: 'bold'
  },
  chevronIcon: {
    marginLeft: 4
  },
  storebarContainer: {
    marginLeft: -16, // to counter the paddingLeft inside Showstorebar.tsx
    marginTop: 5
  },
  logoCard: {
    backgroundColor: 'white',
    borderRadius: 8,
    width: 65,
    height: 65,
    padding: 4,
    justifyContent: 'center',
    alignItems: 'center',
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 4,
    elevation: 3
  },
  logoImage: {
    width: '100%',
    height: '100%'
  },
  logoPlaceholder: {
    backgroundColor: '#e0e0e0'
  },
  logoPlaceholderText: {
    fontSize: 10,
    fontWeight: 'bold',
    color: '#666'
  }
})
